<template>
    <div class="js-form-repeatable-container">
        <div class="js-form-repeatable-repeatables">
            <div
                v-for="(item, index) in modelValue"
                :key="index"
                class="form-repeatable mb-3"
            >
                <div class="form-repeatable__content">
                    <slot :index="index" :item="item" :isFirst="index === 0"></slot>
                </div>
                <div v-if="index > 0" class="form-repeatable__remove">
                    <button
                        type="button"
                        class="form-repeatable__delete"
                        @click="removeItem(index)"
                    >
                        <span class="fa-thin fa-trash-can"></span>
                    </button>
                </div>
            </div>
        </div>
        <div class="text-center">
            <button
                v-if="modelValue.length < maxItems"
                type="button"
                class="button-circle"
                @click="addItem"
            >
                <span class="fa-thin fa-plus"></span>
            </button>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    modelValue: { type: Array, required: true },
    maxItems: { type: Number, default: 20 },
    /** Factory function returning a new empty item */
    createEmpty: { type: Function, default: () => null },
});

const emit = defineEmits(['update:modelValue']);

function addItem() {
    const copy = [...props.modelValue, props.createEmpty()];
    emit('update:modelValue', copy);
}

function removeItem(index) {
    const copy = [...props.modelValue];
    copy.splice(index, 1);
    emit('update:modelValue', copy);
}
</script>
